import { Action } from 'redux';
import { KitActivateFormPayload, KitResponse } from '../../models/kit';
import { APIError } from '../../helpers/types';

export enum KitActionTypes {
  ACTION_KIT_STATUS_SUBMIT = 'KIT_STATUS_SUBMIT',
  ACTION_KIT_STATUS_SUBMIT_SUCCESS = 'KIT_STATUS_SUBMIT_SUCCESS',
  ACTION_KIT_STATUS_SUBMIT_ERROR = 'KIT_STATUS_SUBMIT_ERROR',
  ACTION_KIT_ACTIVATE_SUBMIT = 'KIT_ACTIVATE_SUBMIT',
  ACTION_KIT_ACTIVATE_SUBMIT_SUCCESS = 'KIT_ACTIVATE_SUBMIT_SUCCESS',
  ACTION_KIT_ACTIVATE_SUBMIT_ERROR = 'KIT_ACTIVATE_SUBMIT_ERROR',
}

export interface ActionKitStatusSubmit extends Action {
  type: KitActionTypes.ACTION_KIT_STATUS_SUBMIT;
}
export interface ActionKitStatusSubmitSuccess extends Action {
  type: KitActionTypes.ACTION_KIT_STATUS_SUBMIT_SUCCESS;
  payload: KitResponse;
}
export interface ActionKitStatusSubmitError extends Action {
  type: KitActionTypes.ACTION_KIT_STATUS_SUBMIT_ERROR;
  error: APIError;
}

export interface ActionKitActivateSubmit extends Action {
  type: KitActionTypes.ACTION_KIT_ACTIVATE_SUBMIT;
  payload: KitActivateFormPayload;
}

export interface ActionKitActivateSubmitSuccess extends Action {
  type: KitActionTypes.ACTION_KIT_ACTIVATE_SUBMIT_SUCCESS;
}

export interface ActionKitActivateSubmitError extends Action {
  type: KitActionTypes.ACTION_KIT_ACTIVATE_SUBMIT_ERROR;
  error: APIError;
}

export type KitActions =
  | ActionKitStatusSubmit
  | ActionKitStatusSubmitSuccess
  | ActionKitStatusSubmitError
  | ActionKitActivateSubmit
  | ActionKitActivateSubmitSuccess
  | ActionKitActivateSubmitError
  ;